import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {Translations} from './translations';
import LngDetector from 'i18next-browser-languagedetector';
import backend from "i18next-http-backend";
import { ptBR, enUS, es } from 'date-fns/locale';
import { registerLocale } from  "react-datepicker";

registerLocale('ptBR', ptBR);
registerLocale('enUS', enUS);
registerLocale('esPA', es);
registerLocale('es', es);

i18n
  // pass the i18n instance to react-i18next.
  .use(backend)
  .use(LngDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection:{
      order:['localStorage', 'navigator'],
      lookupLocalStorage: "Idiom"
    },
    // backend: {
    //   loadPath: `${window.location.origin}/locales/{{lng}}/{{ns}}.json`
    // },
    // load: 'all',
    debug: false
  });


export default i18n;